export default "__VITE_ASSET__6c62151d__"